/* eslint-disable @typescript-eslint/no-explicit-any */
import { CSVToArray, excelToJsonCols } from "features/Importar/utils"
import { Checkbox } from "primereact/checkbox"
import { Dropdown } from "primereact/dropdown"
import Dropzone from "react-dropzone"
import { Trans, useTranslation } from "react-i18next"
import subirDocumentoNube from "../../../../../../../assets/subirDocumentoNube.svg"
import { ComponentFormInvitacion, OPTIONS_DROP } from "../../constant"

const MasiveFormInvitacion = ({
  values,
  errors,
  setFieldValue,
  ...props
}: ComponentFormInvitacion) => {
  const { t } = useTranslation()

  const handleUploadExcel = async (acceptedFiles: Blob[]) => {
    const file = acceptedFiles[0]

    const archive =
      file.type === "text/csv"
        ? await CSVToArray(file)
        : await excelToJsonCols(file)

    setFieldValue("masive.archive", archive.items, false)
  }

  const transformObject = (obj: $TSMigrationFixMe) => {
    return Object.entries(obj).map(([label, value]) => ({
      label,
      value,
    }))
  }

  const handleTypeCol = (value: string, keyProp: string) => {
    const { email, razonSocial, nif } = values.masive.options

    const hasErrors = Boolean(
      errors?.masive?.options?.email ||
        errors?.masive?.options?.nif ||
        errors?.masive?.options?.razonSocial
    )
    email &&
      email === keyProp &&
      setFieldValue("masive.options.email", null, hasErrors)
    razonSocial &&
      razonSocial === keyProp &&
      setFieldValue("masive.options.razonSocial", null, hasErrors)
    nif &&
      nif === keyProp &&
      setFieldValue("masive.options.nif", null, hasErrors)

    setFieldValue(`masive.options.${value}`, keyProp, hasErrors)
  }

  const TableComponent = ({ data }: { data: $TSMigrationFixMe[] }) => {
    return (
      <div className='tw-w-full tw-flex tw-flex-col'>
        <div className='tw-w-full tw-overflow-auto'>
          <table className='tw-w-auto'>
            <thead>
              <tr className='tw-h-16 tw-w-auto'>
                {Object.keys(data[0]).map((key: string, index: number) => {
                  return (
                    <th key={key}>
                      <div className='tw-w-48 tw-mx-1 tw-h-full tw-text-nowrap tw-flex tw-items-center'>
                        <Dropdown
                          value={
                            (values.masive.options &&
                              transformObject(values?.masive?.options).find(
                                (element: $TSMigrationFixMe) => {
                                  return element.value === key
                                }
                              )?.label) ??
                            null
                          }
                          options={OPTIONS_DROP}
                          optionValue='id'
                          optionLabel='value'
                          onChange={({ value }: { value: string }) => {
                            handleTypeCol(value, key)
                          }}
                          id={`inputTypeColum${index}`}
                          inputId={`inputTypeColum${index}`}
                          placeholder='Identifique columna'
                          className={`tw-w-48 tw-mx-1 ${
                            errors?.masive?.options ? "tw-border-danger" : ""
                          }`}
                        />
                      </div>
                    </th>
                  )
                })}
              </tr>
            </thead>
            <tbody>
              {data
                .filter((_value: $TSMigrationFixMe, index: number) => index < 3)
                .map((item: $TSMigrationFixMe, index: number) => {
                  return (
                    <tr
                      key={`elementoContainer${index + 1}`}
                      className='tw-h-16 tw-w-auto !tw-border-b !tw-border-neutral-25'
                    >
                      {Object.values(item).map(
                        (value: $TSMigrationFixMe, index: number) => (
                          <td key={`elemento${index + 1}`}>
                            <div className='tw-flex tw-mx-1 tw-h-full tw-text-nowrap tw-px-3 tw-items-center tw-truncate tw-w-48 tw-text-ellipsis'>
                              {value}
                            </div>
                          </td>
                        )
                      )}
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
        <p className='tw-mt-3 tw-mb-0 tw-text-sm tw-w-full'>
          {t("empresasGestionadas.modal.masive.totalAcount")}{" "}
          {data.length ? data.length : "0"}
        </p>
      </div>
    )
  }

  return (
    <div
      key={`${props.key}`}
      className='tw-w-full'
    >
      <div className='tw-flex tw-flex-col'>
        <p className='tw-w-full tw-font-base tw-text-normal tw-mb-6 tw-mt-3'>
          {values?.masive?.archive
            ? t("empresasGestionadas.modal.masive.postText")
            : t("empresasGestionadas.modal.masive.preText")}
        </p>
        <div>
          {values?.masive?.archive ? (
            <TableComponent data={values?.masive?.archive} />
          ) : (
            <Dropzone
              maxSize={4097152}
              accept='application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv'
              onDrop={handleUploadExcel}
              noClick
              noKeyboard
            >
              {({ getRootProps, getInputProps, open }) => (
                <section
                  className={`tw-w-full tw-h-40 tw-border ${
                    errors?.masive?.archive
                      ? "tw-border-danger-20"
                      : "tw-border-neutral-25"
                  } tw-border-dashed !tw-cursor-default`}
                >
                  <div
                    {...getRootProps({ className: "dropzone" })}
                    className='tw-w-full tw-h-full !tw-cursor-default tw-flex tw-flex-row tw-justify-center tw-items-center'
                  >
                    <input
                      className='tw-hidden tw-cursor-default'
                      {...getInputProps()}
                    />
                    <img
                      src={subirDocumentoNube}
                      alt='Imagen subida.'
                      className='tw-w-40 tw-h-28 tw-cursor-default'
                    />
                    <div className='tw-flex tw-flex-col tw-items-start tw-justify-center tw-h-fit tw-ml-8 tw-cursor-default'>
                      <p className='tw-w-64 tw-text-wrap'>
                        <Trans
                          i18nKey='empresasGestionadas.modal.masive.addText'
                          components={[
                            <span
                              className='tw-text-info-100 tw-cursor-pointer'
                              key='0'
                              onClick={open}
                            />,
                          ]}
                        />
                      </p>
                      <div
                        className='tw-px-4 tw-py-2.5 !tw-bg-primary !tw-text-simple-10 tw-rounded tw-cursor-pointer'
                        onClick={open}
                      >
                        {t("empresasGestionadas.modal.masive.searchText")}
                      </div>
                    </div>
                  </div>
                </section>
              )}
            </Dropzone>
          )}
        </div>
        <div className='tw-w-full tw-my-6 tw-flex tw-flex-row'>
          <Checkbox
            onChange={() => {
              setFieldValue("policityMasive", !values.policityMasive, false)
            }}
            inputId='policityMasive'
            className={`${errors.policityMasive ? "p-invalid" : ""}`}
            checked={values.policityMasive}
          />
          <p className='tw-flex-wrap tw-text-wrap tw-ml-3'>
            <Trans
              i18nKey='empresasGestionadas.modal.simple.policity'
              components={[
                <span
                  className={`tw-text-info-100 tw-cursor-pointer ${
                    values.showModalPoliciyMasive ? "tw-hidden" : ""
                  }`}
                  key='0'
                  onClick={() =>
                    setFieldValue("showModalPoliciyMasive", true, false)
                  }
                />,
              ]}
            />
            {values.showModalPoliciyMasive && (
              <Trans
                i18nKey='empresasGestionadas.modal.simple.policityShowMore'
                components={[
                  <a
                    href='https://finanedi.es/proteccion-datos.html'
                    className='tw-text-info-100 tw-cursor-pointer'
                    target='_blank'
                    rel='noopener noreferrer'
                    key='0'
                  />,
                  <a
                    href='https://finanedi.es/aviso-legal.html'
                    className='tw-text-info-100 tw-cursor-pointer'
                    target='_blank'
                    rel='noopener noreferrer'
                    key='1'
                  />,
                ]}
              />
            )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default MasiveFormInvitacion
